import {
  FETCH_MERCHANT_ORDERS_REQUEST,
  FETCH_MERCHANT_ORDERS_SUCCESS,
  FETCH_MERCHANT_ORDERS_FAILURE,
  MAKE_ORDER_READY_REQUEST,
  MAKE_ORDER_READY_SUCCESS,
  MAKE_ORDER_READY_FAILURE,
  UPDATE_ORDER_STATUS_REQUEST,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAILURE,
} from "../actions/types";

const initialState = {
  orders: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  size: 10,
  pages: 1,

  makeReadyLoading: false,
  makeReadyError: null,

  updateStatusLoading: false,
  updateStatusError: null,
};

export default function orderReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_MERCHANT_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_MERCHANT_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.orders,
        total: action.payload.total,
        page: action.payload.page,
        size: action.payload.size,
        pages: action.payload.pages,
      };

    case FETCH_MERCHANT_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case MAKE_ORDER_READY_REQUEST:
      return {
        ...state,
        makeReadyLoading: true,
        makeReadyError: null,
      };

    case MAKE_ORDER_READY_SUCCESS:
      return {
        ...state,
        makeReadyLoading: false,
        orders: state.orders.map((order) =>
          order.order_id === action.payload.order_id
            ? { ...order, status: "READY" }
            : order
        ),
      };

    case MAKE_ORDER_READY_FAILURE:
      return {
        ...state,
        makeReadyLoading: false,
        makeReadyError: action.payload,
      };

    case UPDATE_ORDER_STATUS_REQUEST:
      return {
        ...state,
        updateStatusLoading: true,
        updateStatusError: null,
      };

    case UPDATE_ORDER_STATUS_SUCCESS:
      return {
        ...state,
        updateStatusLoading: false,
        orders: state.orders.map((order) =>
          order.order_id === action.payload.order_id
            ? { ...order, status: action.payload.status }
            : order
        ),
      };

    case UPDATE_ORDER_STATUS_FAILURE:
      return {
        ...state,
        updateStatusLoading: false,
        updateStatusError: action.payload,
      };

    default:
      return state;
  }
}